import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './freeCriteriaView.html';

export class FreeCriteriaComponent {
    /* @ngInject */
    constructor($timeout, $element) {
        const freeCriteriaCtrl = this;

        freeCriteriaCtrl.initData = function () {
            freeCriteriaCtrl.showTextBox = false;
            freeCriteriaCtrl.mandatoryValues = [
                {
                    value: 'optional',
                    text: 'NORMAL',
                },
                {
                    value: 'mandatory',
                    text: 'MANDATORY_MINUS',
                },
                {
                    value: 'filter',
                    text: 'MANDATORY',
                },
            ];
            freeCriteriaCtrl.requiredIndexes = [];
            for (let i = 0; i < freeCriteriaCtrl.data.selected.length; i++) {
                const element = freeCriteriaCtrl.data.selected[i];
                if (element.required === true) {
                    element.required = 'mandatory';
                } else if (!element.required) {
                    element.required = 'optional';
                } else if (element.required === 0 || element.required === false) {
                    element.required = 'optional';
                }
                const index = _.findIndex(freeCriteriaCtrl.mandatoryValues, {value: element.required});
                if (index >= 0) {
                    freeCriteriaCtrl.requiredIndexes.push({
                        requiredValue: index,
                    });
                } else {
                    freeCriteriaCtrl.requiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            }
        };

        freeCriteriaCtrl.removeValue = function () {
            freeCriteriaCtrl.data.selected.splice(0, 1);
            freeCriteriaCtrl.requiredIndexes.splice(0, 1);
        };

        freeCriteriaCtrl.goToBottom = function () {
            if ($element[0].getBoundingClientRect().bottom > document.documentElement.clientHeight) {
                const scrollTop = $(window)
                    .scrollTop();
                $timeout(() => {
                    $(window)
                        .scrollTop(($element[0].getBoundingClientRect().bottom - document.documentElement.clientHeight)
                            + scrollTop + 20);
                }, 200);
            }
        };

        freeCriteriaCtrl.addValue = function () {
            if (freeCriteriaCtrl.newValue && freeCriteriaCtrl.newValue !== '') {
                if (freeCriteriaCtrl.data.selected.length === 0) {
                    freeCriteriaCtrl.data.selected.push({
                        value: freeCriteriaCtrl.newValue,
                        required: freeCriteriaCtrl.defaultMandatoryValue || 'optional',
                    });
                    freeCriteriaCtrl.initData();
                } else {
                    freeCriteriaCtrl.data.selected[0].value = freeCriteriaCtrl.newValue;
                }
            }
            freeCriteriaCtrl.showTextBox = false;
            freeCriteriaCtrl.newValue = '';
        };

        freeCriteriaCtrl.modifyValue = function () {
            freeCriteriaCtrl.newValue = freeCriteriaCtrl.data.selected[0].value;
            freeCriteriaCtrl.showTextBox = true;
        };

        freeCriteriaCtrl.setRequiredSubCriteria = function (idx, value) {
            freeCriteriaCtrl.mandatoryPopUpView = -1;
            freeCriteriaCtrl.data.selected[idx].required = value.required;
            const index = _.findIndex(freeCriteriaCtrl.mandatoryValues, {value: freeCriteriaCtrl.data.selected[idx].required});
            if (freeCriteriaCtrl.requiredIndexes.length <= 0) {
                if (index >= 0) {
                    freeCriteriaCtrl.requiredIndexes.push({
                        requiredValue: index,
                    });
                } else {
                    freeCriteriaCtrl.requiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            } else if (index >= 0) {
                if (freeCriteriaCtrl.requiredIndexes[idx]) {
                    freeCriteriaCtrl.requiredIndexes[idx].requiredValue = index;
                } else {
                    freeCriteriaCtrl.requiredIndexes.push({
                        requiredValue: index,
                    });
                }
            } else if (freeCriteriaCtrl.requiredIndexes[idx]) {
                freeCriteriaCtrl.requiredIndexes[idx].requiredValue = 0;
            } else {
                freeCriteriaCtrl.requiredIndexes.push({
                    requiredValue: index,
                });
            }
        };

        freeCriteriaCtrl.setPopupView = function (value) {
            freeCriteriaCtrl.mandatoryPopUpView = value;
        };
    }
}

export const FreeCriteriaComponentConfiguration = {
    bindings: {
        data: '=',
        allData: '=',
        disable: '=',
        showSettingsPopup: '<',
        defaultMandatoryValue: '<',
    },
    controller: FreeCriteriaComponent,
    template,
    controllerAs: 'freeCriteriaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('freeCriteriaComponent', FreeCriteriaComponentConfiguration);
